<template>
  <div class="range-bar" @mouseleave="dragEnd">
    <span class="title" @click.stop.prevent="show">
      PRICE RANGE
      <i class="down-arrow-icon"></i>
    </span>
    <div class="dropdown-box" :id="componentID">
      <div class="slider-box" :id="sliderBox">
        <div class="range-number">
          {{ getCurrency }} {{ rangePrice.start }} - {{ rangePrice.end }}
        </div>
        <div class="graph">
          <span
            class="square"
            v-for="item in priceRange"
            :style="{
              height: (item * 0.1 >= 50 ? 50 : item * 0.1) + 'px',
              width: 100 / priceRange.length + '%'
            }"
            :key="item.id"
          ></span>
        </div>
        <div class="slider-bar">
          <div
            class="dot end"
            @mousedown.prevent.stop="dragStart"
            draggable="false"
          ></div>
          <div
            class="dot start"
            @mousedown.prevent.stop="dragStart"
            draggable="false"
          ></div>
        </div>
        <div
          :id="sliderDragBox"
          class="slider-bar-drag-box"
          @mouseup="dragEnd"
          @mouseleave="dragEnd"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import * as types from '../../store/mutation-types'

export default {
  name: 'range-bar',
  props: {
    priceRange: {
      default: () => [10, 20, 30, 40, 54, 60, 70, 85, 90, 139, 220, 310, 441],
      type: Array
    },
    currency: {
      default: 'GBP',
      type: String
    }
  },
  data() {
    return {
      target: '',
      componentID: new Date().getTime().toString() + 'C',
      sliderDragBox: new Date().getTime().toString(),
      sliderBox: new Date().getTime().toString() + 'A',
      rangePrice: {
        start: 0,
        end: 0
      },
      startLeft: 0,
      endLeft: 240,
      startId: '',
      endId: ''
    }
  },
  watch: {
    priceRange(newValue, oldValue) {
      console.log('price range:', newValue, oldValue)
      if (newValue !== oldValue) {
        this.rangePrice.start = newValue[0]
        this.rangePrice.end = newValue[newValue.length - 1]
      }
    }
  },
  mounted() {
    console.log('priceRange:', this.priceRange)
    this.startId = window.document.getElementsByClassName('start')
    this.endId = window.document.getElementsByClassName('end')
  },
  methods: {
    show() {
      this.$store.dispatch(types.SET_GLOBAL_DROPDOWNMODE, 'clear')
      const el = window.document.getElementById(this.componentID)
      // console.log(el.className)
      if (el.className === 'dropdown-box') {
        el.className += ' active'
      } else {
        el.className = 'dropdown-box'
      }
    },
    dragStart(e) {
      this.$el.addEventListener('mousemove', this.mouseMove)
      // console.log('drag start')
      this.target = e
      let drag = window.document.getElementById(this.sliderDragBox)
      drag.style.zIndex = '100'
    },
    mouseMove(e) {
      e.preventDefault()
      e.stopPropagation()
      const className = this.target.target.className.split(' ')[1]
      let nextMove = e.offsetX - 15

      // let shiftX = e.clientX - e.target.getBoundingClientRect().left
      // let shiftY = e.clientY - e.target.getBoundingClientRect().top
      // console.log(shiftX, shiftY)

      if (className === 'start') {
        if (nextMove < 0) {
          nextMove = 0
        }
        this.startLeft = nextMove
        if (this.startLeft <= this.endLeft) {
          this.target.target.style.left = nextMove + 'px'
          this.changePrice(nextMove, className)
        }
      } else {
        this.endLeft = nextMove
        if (this.endLeft >= this.startLeft) {
          this.target.target.style.left = nextMove + 'px'
          this.changePrice(nextMove, className)
        }
      }
    },
    dragEnd(e) {
      e.preventDefault()
      e.stopPropagation()
      this.$el.removeEventListener('mousemove', this.mouseMove)
      let drag = window.document.getElementById(this.sliderDragBox)
      drag.style.zIndex = '-1'
      if (this.target) {
        const className = this.target.target.className.split(' ')[1]
        let nextMove = e.offsetX - 15

        if (className === 'start') {
          if (nextMove < 0) {
            nextMove = 0
          }
          // this.startLeft = nextMove
          // if (this.startLeft <= this.endLeft) {
          //     this.changePrice(nextMove, className)
          // }
        } else {
          // this.endLeft = nextMove
          // if (this.endLeft >= this.startLeft) {
          //     this.changePrice(nextMove, className)
          // }
        }
        setTimeout(() => {
          this.target = ''
          this.send()
        }, 500)
      }
    },
    changePrice(leftValue, className) {
      const standWidth = parseInt(240 / this.priceRange.length, 10)
      const indexValue = parseInt(leftValue / standWidth, 10)
      if (className === 'start') {
        console.log('start :', this.priceRange[indexValue])
        this.$set(this.rangePrice, 'start', this.priceRange[indexValue])
      } else {
        console.log('end :', this.priceRange[indexValue])
        this.$set(this.rangePrice, 'end', this.priceRange[indexValue])
      }
    },
    send: _.debounce(
      function() {
        console.log('Send rangePrice:', this.rangePrice)
        this.$emit('model', this.rangePrice)
      },
      // 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
      1000
    )
  },
  updated() {
    // console.log(this.startLeft, this.endLeft)
    try {
      if (this.endLeft < 20) {
        console.log('start less')
        this.startId[0].style.zIndex = 0
        this.endId[0].style.zIndex = 1
      }

      if (this.startLeft > 200) {
        this.startId[0].style.zIndex = 1
        this.endId[0].style.zIndex = 0
      }
    } catch (e) {
      console.error(e)
    }
  },
  computed: {
    getCurrency() {
      switch (this.currency) {
        case 'GBP':
          return '£'
        default:
          return '£'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.range-bar {
  width: 123px;
  /*border: 1px solid red;*/
  position: relative;

  .title {
    width: 102px;
    height: 23px;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    text-align: left;
    color: #000000;
    cursor: pointer;

    .down-arrow-icon {
      margin: 0 0 0 8px;
      width: 16px;
      height: 9px;
      /*border: 1px solid red;*/
      display: inline-block;
      background-image: url('../../assets/images/etc/down-arrow.png');
    }
  }

  .dropdown-box {
    .slider-box {
      .graph {
        /*border: 1px solid blue;*/
        height: 51px;
        display: flex;
        flex-wrap: nowrap;
        width: 240px;
        position: relative;
        margin: 60px auto auto auto;

        .square {
          text-align: center;
          margin-top: auto;
          display: inline-block;
          background-color: #dbdbdb;
          content: '';
          position: relative;
          bottom: 0;
        }
      }

      .slider-bar {
        z-index: 10;
        width: 240px;
        height: 4px;
        background-color: #0f00ff;
        position: relative;
        margin: auto;

        .dot {
          cursor: pointer;
          top: -13px;
          background-color: #ffffff;
          position: absolute;
          display: block;
          width: 22px;
          height: 22px;
          border-radius: 30px;
          border: 4px solid #0f00ff;
        }

        .start {
          left: 0;
          z-index: 10;
        }

        .end {
          left: 230px;
          z-index: 10;
        }
      }

      .slider-bar-drag-box {
        left: 0;
        right: 0;
        margin: auto;
        z-index: -1;
        top: 20px;
        width: 240px;
        height: 100px;
        opacity: 0;
        /*visibility: hidden;*/
        background-color: #0f00ff;
        position: absolute;
        border: 1px solid red;
        cursor: pointer;
      }

      .range-number {
        position: absolute;
        top: 20px;
        left: 30px;
        font-size: 16px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        text-align: left;
        color: #000000;
        transition: all 5s ease-in-out;
      }
    }

    top: -1px;
    width: 300px;
    height: 0;
    z-index: -1;
    margin: 20px 0 0 0;
    background-color: #ffffff;
    position: relative;
    border: 1px solid #cbcbcb;
    visibility: hidden;
    opacity: 0;

    &:before {
      position: absolute;
      top: -12px;
      left: 40px;
      z-index: 1001;
      content: '';
      width: 20px;
      height: 20px;
      border-top: 1px solid #cbcbcb;
      border-right: 1px solid #cbcbcb;
      transform: rotate(315deg);
      background-color: #fff;
    }

    -webkit-transition-property: width height background-color font-size left
      top transform -webkit-transform color;
    -webkit-transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-in-out;

    -moz-transition-property: width height background-color font-size left top
      transform -moz-transform color;
    -moz-transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in-out;

    -ms-transition-property: width height background-color font-size left top
      transform -ms-transform color;
    -ms-transition-duration: 0.3s;
    -ms-transition-timing-function: ease-in-out;

    -o-transition-property: width height background-color font-size left top
      transform -o-transform color;
    -o-transition-duration: 0.3s;
    -o-transition-timing-function: ease-in-out;

    transition-property: width height background-color font-size left top
      transform transform color;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }

  .active {
    height: 159px;
    z-index: 1000;
    opacity: 1;
    visibility: visible;

    -webkit-transition-property: width height background-color font-size left
      top transform -webkit-transform color;
    -webkit-transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-in-out;

    -moz-transition-property: width height background-color font-size left top
      transform -moz-transform color;
    -moz-transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in-out;

    -ms-transition-property: width height background-color font-size left top
      transform -ms-transform color;
    -ms-transition-duration: 0.3s;
    -ms-transition-timing-function: ease-in-out;

    -o-transition-property: width height background-color font-size left top
      transform -o-transform color;
    -o-transition-duration: 0.3s;
    -o-transition-timing-function: ease-in-out;

    transition-property: width height background-color font-size left top
      transform transform color;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }
}
</style>
